<template lang="pug">
  v-container(fluid)
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        h1 {{ translations.title }}
    //- Selector de competiciones
    v-row.px-2.px-sm-10.pb-10
      CompetitionSelectorCollapsable(:info="translations.info" :competitionListAll="competitionListAll" @cardClicked="getPlayers" :competitionid="$route.params.competitionid")

    v-row.px-2.px-sm-10.pb-10(v-if="createLoad" align="center" justify="center")
      //- filtros
      v-col(cols="12" lg="6" md="6" sm="12")
        v-text-field(v-model="namefilter"  :label="translations.searchLabel" clearable)
      v-col(cols="12" lg="6" md="6" sm="12")
        v-select(v-model="positionfilter"  :items="position" item-text="text" item-value="value" return-object :label="translations.tableHeadText.role" clearable)

      //- vista como table
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td {{ item.height }}
                td {{ item.weight }}
                td {{ item.role }}
                td
                  PlayerCompetitionInfoDialog(v-bind="[item,$t('components.playerCompetitionInfoDialog')]")

        BaseConfirmDialog(v-if="hasPermission('views.fantasy.players.bulkPlayers')" @confirm="sendBulkForm()" v-bind="translations.confirmationDialog.bulk")
          template(v-slot="{ on }")
            v-btn(v-on="on" class="mx-2" style="bottom:50px" fab primary right fixed).orange--text
              v-icon mdi-upload
</template>

<script>
  import CompetitionSelectorCollapsable from "@/components/selectors/CompetitionSelectorCollapsable";
  import PlayerCard from "@/components/cards/PlayerCard";
  import PlayerCompetitionInfoDialog from "@/components/dialogs/info/PlayerCompetitionInfoDialog";

  export default {
    name: "FantasyPlayersIndex",
    components:{
      PlayerCompetitionInfoDialog,
      PlayerCard,
      CompetitionSelectorCollapsable,
    },
    data:() => ({
      createLoad: false,
      competitionSelected:'',
      positionfilter: {
        text: '',
        value: ''
      },
      namefilter: '',
    }),
    computed: {
      translations(){
        return this.$t("views.playersIndex");
      },
      headers(){
        return [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.height,
            value: 'height'
          },
          {
            text: this.translations.tableHeadText.weight,
            value: 'weight'
          },
          {
            text: this.translations.tableHeadText.role,
            value: 'role'
          },
          {
            text: '',
            value: 'stats',
            sortable: false
          },
        ]
      },
      datos(){
        const vm = this;
        return this.playersFiltered.map(player =>{
          return {
            name: player.name,
            height: player.height,
            weight: player.weight,
            role:  player.role != ''? vm.$t('back.role.'+ player.role) : '',
            competitions: player.competitions
          }
        })
      },
      position(){
        return [
          {
            text: this.$t('back.role.gk'),
            value: 'gk'
          },
          {
            text: this.$t('back.role.df'),
            value: 'df'
          },
          {
            text: this.$t('back.role.mf'),
            value: 'mf'
          },
          {
            text: this.$t('back.role.fw'),
            value: 'fw'
          },
        ];
      },
      playersList(){
        return this.$store.state.fantasy.players;
      },
      playersFiltered(){
        const vm = this;

        const filters = {
          role: {
            function: vm.filterRole,
            condition: vm.positionfilter
          },
          name: {
            function: vm.filterName,
            condition: vm.namefilter
          }
        };

        return this.playersList.filter(player => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](player, filters[key]['condition']);
          });
        });
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions;
      }
    },
    created(){
      this.createLoad = false;
      this.$store.dispatch('getCompetitions');
    },
    methods:{
      filterRole(item, condition){
        return condition == undefined || condition.value == '' || item.role == condition.value;
      },
      filterName(item, condition){
        return condition == undefined || condition == '' || item.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      sendBulkForm(){
        let data = {
          action:'player',
          competition: this.competitionSelected,
        };

        this.$store.dispatch('actionBulkLoad',data);
      },
      getPlayers(competitionId){
        if(this.createLoad == false){
          this.createLoad = true;
        }
        this.competitionSelected = competitionId;
        this.$store.dispatch('getPlayers', competitionId);
      },
    }
  }
</script>

<style lang="sass">
</style>